import GLOBAL from './global';

function testSupportLS() {
    const curLocalStorage = GLOBAL.localStorage;
    if (!curLocalStorage) {
        return false;
    }
    try {
        const testKey = 'prajna_ls_test';
        curLocalStorage.setItem(testKey, '1');
        curLocalStorage.removeItem(testKey);
        return true;
    } catch (error) {
        return false;
    }
}

const supportLS = testSupportLS();

export default {
    get(name: string): any {
        if (supportLS) {
            return GLOBAL.localStorage.getItem(name);
        } else {
            return 'get fail';
        }
    },
    set(name: string, val: any) {
        if (supportLS) {
            GLOBAL.localStorage.setItem(name, val);
        }
    },
};



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/util/localStorage.ts